import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { UitkLayoutFlex } from 'uitk-react-layout-flex';

import { z } from 'zod';

export const ListViewLayout: React.FC<TemplateComponentProps> = ({ templateComponent: { children, config } }) => {
  const configSchema = z.optional(
    z.object({
      reverse: z.boolean(),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success || !children) {
    return null;
  }

  const { reverse } = result.data ?? {};

  return (
    <Viewport>
      <ViewLarge>
        <UitkLayoutFlex direction={reverse ? 'row-reverse' : 'row'}>
          <ExperienceTemplateRenderer templateComponents={children} />
        </UitkLayoutFlex>
      </ViewLarge>
      <ViewSmall>
        <UitkLayoutFlex direction="column">
          <ExperienceTemplateRenderer templateComponents={children} />
        </UitkLayoutFlex>
      </ViewSmall>
    </Viewport>
  );
};
